import SvgCheckCircle from '../Icons/CheckCircle';

type Props = {
  message?: string;
};

const SuccessToast = ({ message }: Props) => {
  return (
    <div className="flex h-[44px] w-[500px] flex-row items-center justify-center gap-x-[10px] border-[1px] border-solid border-elfGreen bg-greenLight">
      <SvgCheckCircle className="text-elfGreen" width={24} height={24} />
      <span className="font-workSans text-[14px] font-normal leading-[21px] text-elfGreen">
        {message}
      </span>
    </div>
  );
};

export default SuccessToast;
